import styled from '@emotion/styled';
import { Button, type ITheme } from '../../../../../../ui';
import themed from '../../../../../../ui/themer/themed';
import Responsive from '../../../../../../ui/utils/Responsive';
import { Color } from '../../../../styles/Color';

export const StyledButtonAsLink = styled(Button)<{ open: boolean }, ITheme>`
	height: auto;
	width: max-content;
	line-height: unset;
	padding: 0;

	display: flex;
	justify-content: start;
	align-items: center;
	gap: 2px;

	font-family: inherit;
	border: 0;
	color: ${({ open }) =>
		open ? Color.TextWhite : themed(({ typography }) => typography.body.color)};

	svg {
		margin: 0;
	}
	border-radius: 4px;
	padding: 5px 8px;
	background: ${({ open }) => (open ? Color.PrimaryDefault : 'none')};
	box-shadow: none;

	&:hover,
	&:hover:not(:disabled) {
		background: ${Color.PrimaryDefault};
		border: none;
		color: ${Color.TextWhite};
	}
	&:focus-visible {
		background: ${Color.PrimaryDefault};
		color: ${Color.TextWhite};
		-webkit-text-decoration: underline;
		text-decoration: underline;
		outline: 2px solid ${Color.Highlight};
	}
	&:active:not(:disabled) {
		box-shadow: none;
		transform: none;
	}
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		width: 100%;
		gap: 8px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
`;
